import styles from './index.module.scss'
import { Divider, Table, message, Button, Select, Pagination } from 'antd'
import { useState, useEffect } from 'react'
import eventBus from '@utils/eventBus';
import API from '@api/api';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { useNavigate } from "react-router-dom";



const RedemptioncodeList = () => {
     const navigate = useNavigate();
    const [logLoading, setLogLoading] = useState(false)
    const [stockStatisticsData, setStockStatisticsData] = useState([])
    const [stockStatisticsTotal, setStockStatisticsTotal] = useState(0)
    const [activateStatisticsData, setActivateStatisticsData] = useState([])
    const [activateStatisticsTotal, setActivateStatisticsTotal] = useState(0)
    const [currentTop, setCurrentTop] = useState(0)
    const [state, setState] = useState()
    const [planId, setPlanId] = useState()
    const [planIdData, setPlanIdData] = useState([])
    const [pageIndex, setPageIndex] = useState(1)
    const [paginationTotal, setPaginationTotal] = useState(0)
    const [listOrderedPlanData, setListOrderedPlanData] = useState([])
    const [sortField, setSortField] = useState() //activateTime or orderTime
    const [order, setOrder] = useState() //asc or desc


    const orderColumns = [{
        title: '序号',
        width: 80,
        key: 'orderColumns',
        render: (text, record, index) => index + 1,
    }, {
        title: '套餐',
        dataIndex: 'planName',
        key: 'planName',
    }, {
        title: '进货价格',
        dataIndex: 'planPrice',
        key: 'planPrice',
    }, {
        title: '兑换码',
        dataIndex: 'serialKey',
        key: 'serialKey',
    }, {
        title: '订单号',
        dataIndex: 'orderId',
        key: 'orderId',
    }, {
        title: '购买日期',
        width: 200,
        dataIndex: 'orderTime',
        key: 'orderTime',
        sorter: true,
        sortOrder: sortField === 'orderTime' && order,
    }, {
        title: '激活日期',
        width: 200,
        dataIndex: 'activateTime',
        key: 'activateTime',
        sorter: true,
        sortOrder: sortField === 'activateTime' && order,
    }, {
        title: '激活状态',
        width: 100,
        fixed: 'right',
        key: 'state',
        render: (record) => record.state == 1 ? <span style={{ color: '#34C759' }}>已激活</span> : <span style={{ color: '#B9C3D0' }}>未激活</span>,
    },
    {
        title: '操作',
        fixed: 'right',
        width: 100,
        render: (record) => <span
            onClick={() => {
                if (record.state == 1) return
                copyLink(record.serialKey)
            }}
            style={{ color: record.state === 0 ? '#0096FF' : '#B9C3D0', cursor: 'pointer' }}
        >复制</span>,
    }]


    const stockStatistics = () => {
        API.stockStatistics({
        }).then((res) => {
            if (res.code == 0) {
                setStockStatisticsData(res.data.statistics || [])
                setStockStatisticsTotal(res.data.total || 0)
            } else message.error(res.message)
        })
    }

    const activateStatistics = () => {
        API.activateStatistics({
        }).then((res) => {
            if (res.code == 0) {
                setActivateStatisticsData(res.data.statistics || [])
                setActivateStatisticsTotal(res.data.total || 0)
            } else message.error(res.message)
        })
    }

    const listPlanSelect = () => {
        API.listPlanSelect({
        }).then((res) => {
            if (res.code == 0) {
                const data = res.data || []
                setPlanIdData(data.map(item => ({
                    label: item.display,
                    value: item.value,
                })))
            } else message.error(res.message)
        })
    }

    const listOrderedPlan = () => {
        API.listOrderedPlan({
            pageIndex,
            pageSize: 20,
            planId,
            state,
            sortField,
            order: order === 'ascend' ? 'asc' : order === 'descend' ? 'desc' : null,
        }).then((res) => {
            if (res.code == 0) {
                setListOrderedPlanData(res.data.items || [])
                setPaginationTotal(res.data.total || 0)
            } else if(res.code == -5069) {
                navigate('/home/product/batchImages')
            } else message.error(res.message)
        })
    }

    useEffect(() => {
        stockStatistics()
        activateStatistics()
        listPlanSelect()
    }, [])

    useEffect(() => {
        setPageIndex(1);
    }, [planId, state]);

    const refresh = () => {
        stockStatistics()
        activateStatistics()
        listOrderedPlan()
    }


    useEffect(() => {
        listOrderedPlan()
    }, [pageIndex, planId, state, sortField, order])

    const copyLink = (link) => {
        if (!link) return;
        const fullLink = link.replace(/-/g, '');

        // 如果 clipboard API 可用
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(fullLink)
                .then(() => {
                    message.success('复制成功');
                })
                .catch(err => {
                    console.error('Clipboard error:', err);
                    message.error('复制失败，请手动复制');
                });
        } else {
            // 兼容旧浏览器
            const textarea = document.createElement('textarea');
            textarea.value = fullLink;
            textarea.style.position = 'fixed';
            textarea.style.top = '-9999px';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();

            try {
                const success = document.execCommand('copy');
                if (success) {
                    message.success('复制成功');
                } else {
                    message.warning('复制失败，请手动复制');
                }
            } catch (err) {
                console.error('Fallback copy error:', err);
                message.error('复制失败，请手动复制');
            }
            document.body.removeChild(textarea);
        }
    }

    const listNotActivateKeys = () => {
        API.listNotActivateKeys({
        }).then((res) => {
            if (res.code == 0) {
                handleDownload(res.data || [])
            } else message.error(res.message)
        })
    }

    const handleDownload = (data) => {
        const excelHeader = ["套餐", "兑换码"];

        const sheetData = [
            excelHeader,
            ...data.map(item => [
                item.planName,
                item.serialKey,
                // item.orderId || "",
                // item.orderTime
            ])
        ];

        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "未激活兑换码");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(blob, `未激活兑换码_${Date.now()}.xlsx`);
    };



    return (
        <div className={styles.RedemptioncodeList}>
            <div className={styles.topWrap}>
                <p className={styles.changeBtn}>
                    <span className={currentTop == 0 ? styles.active : ''} onClick={() => setCurrentTop(0)}>库存概览</span>
                    <span className={currentTop == 1 ? styles.active : ''} onClick={() => setCurrentTop(1)}>套餐占比</span>
                </p>
                {
                    currentTop ? <div className={styles.topWrapLeft}>
                        <div className={styles.topItem}><p>{activateStatisticsTotal}</p><p>激活套餐总数</p></div>
                        <Divider className={styles.divider} type="vertical" />
                        {
                            activateStatisticsData?.map((item) => (
                                <div key={item.planId} className={styles.topItem}><p>{item.percent}<span style={{ fontSize: '12px', fontWeight: 400 }}>%</span></p><p>{item.planName}</p></div>
                            ))
                        }
                    </div> : <div className={styles.topWrapLeft}>
                        <div className={styles.topItem}><p>{stockStatisticsTotal}</p><p>库存套数</p></div>
                        <Divider className={styles.divider} type="vertical" />
                        {
                            stockStatisticsData?.map((item) => (
                                <div key={item.planId} className={styles.topItem}><p>{item.total}</p><p>{item.planName}</p></div>
                            ))
                        }
                    </div>
                }
                <Button type="primary" className={styles.buyBtn} onClick={() => eventBus.emit('OPEN_CHANNEL_BUY_PACKAGE', refresh)}>购买</Button>
            </div>
            <div className={styles.tableWrap}>
                <div className={styles.filter}>
                    <Select
                        style={{ width: 160 }}
                        optionFilterProp="label"
                        value={state}
                        allowClear
                        onChange={setState}
                        placeholder="全部激活状态"
                        options={[{
                            label: '未激活',
                            value: 0,
                        }, {
                            label: '已激活',
                            value: 1,
                        }]}
                    />
                    <Select
                        style={{ width: 160, marginLeft: 12 }}
                        optionFilterProp="label"
                        value={planId}
                        allowClear
                        onChange={setPlanId}
                        placeholder="全部套餐类型"
                        options={planIdData}
                    />
                    <span className={styles.inviteMember} onClick={listNotActivateKeys}>导出未激活兑换码</span>
                </div>
                <Table
                    className='personalTable'
                    loading={logLoading}
                    rowKey="title"
                    columns={orderColumns}
                    dataSource={listOrderedPlanData}
                    tableLayout="auto"
                    pagination={false}
                    scroll={{
                        x: 'max-content',
                        y: `calc(100vh - 500px)`,
                    }}
                    onChange={(pagination, filters, sorter) => {
                        if (sorter.field) {
                            setSortField(sorter.field);
                            setOrder(sorter.order);
                        } else {
                            setSortField('');
                            setOrder('');
                        }
                    }}
                />
                <div className={styles.PaginationWarp}>
                    <Pagination
                        showQuickJumper
                        total={paginationTotal}
                        onChange={setPageIndex}
                        pageSize={20}
                        current={pageIndex}
                        showSizeChanger={false} />
                </div>
            </div>
        </div>
    )
}

export default RedemptioncodeList